import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-pack-icon',
  templateUrl: './pack-icon.component.svg',
  styleUrls: ['./pack-icon.component.css'],
})
export class PackIconComponent {
  @Input() color!: string;
}
